import {
	useFormErrorNotification,
	useFormSuccessNotification,
} from "@babackapp/react-hook-forms-components/form-notifications";
import { useMutation } from "@tanstack/react-query";
import { $api } from "../generated/client";
import useInvalidateShop from "./use-invalidate-shop";

type UseRemoveShopLogoParams = {
	shopId: string;
};

export default function useRemoveShopLogo({ shopId }: UseRemoveShopLogoParams) {
	const successNotification = useFormSuccessNotification();
	const errorNotification = useFormErrorNotification();
	const invalidateShop = useInvalidateShop(shopId);
	const mutation = $api.useMutation("delete", "/shops/{shopId}/logo");

	return useMutation({
		onError: () => {
			errorNotification();
		},
		onSuccess: () => {
			invalidateShop();
			successNotification();
		},
		mutationFn: async () => {
			return mutation.mutateAsync({
				params: { path: { shopId } },
			});
		},
	});
}
